export default{
  SET_PAGE_TITLE(store,dt){
    store.PAGE_TITLE = dt;
  },
  SET_MENU_LIST(store,dt){
    store.MENU_LIST = dt;
  }
}


// WEBPACK FOOTER //
// ./src/store/mutations/index.js